module.exports = __webpack_public_path__ + "static/img/aqzs24.18962c94.jpg";